/**
 * Catalogued ops event types for intentional logger beacons.
 * Prefer these over free-text-only logs when something will be dashboarded.
 *
 * RUM custom-event type pattern: [\w\-:/.#\[\]]+
 */

export const LOG_EVENT_TYPES = Object.freeze({
    /** User-visible React ErrorBoundary fallback (PRD-2906). */
    ERROR_BOUNDARY: 'com.lyt.portal.error_boundary',
    /** Generic error when no catalogued event_type is provided. */
    LOG_ERROR: 'com.lyt.portal.log.error',
    /** Prefix for logger.performance(name) → com.lyt.portal.performance.<name> */
    PERFORMANCE_PREFIX: 'com.lyt.portal.performance.',
});
